export default __webpack_public_path__ + "static/changeDetection-1d0a08a2d59600fe667d3a5d1f0e2964.gif";